import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IPublishTermsSuccessPayload } from '../../../types/publishTermsPayload';

export const LOAD_PUBLISH_TERMS_SUCCESS = 'PUBLISH_TERMS :: LOAD_SUCCESS';

export type TLoadPublishTermsSuccessAction = IReduxAction<
  typeof LOAD_PUBLISH_TERMS_SUCCESS,
  IPublishTermsSuccessPayload
>;

export const loadPublishTermsSuccess = actionGenerator<typeof LOAD_PUBLISH_TERMS_SUCCESS, IPublishTermsSuccessPayload>(
  LOAD_PUBLISH_TERMS_SUCCESS,
);
